// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_1Z3j8","apps":"_1akmY","brandRow":"jOgDX","wordmark":"YWkA1","badgeLink":"_2eaK9","badge":"_2N6UZ","social":"_tbQb"};